import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { commonDescendingComparator, momentDescendingComparator } from 'utils/helper';

export const useRubricTableColumns = () => {
    const { t } = useTranslation();

    return [
        {
            id: 'name',
            columnTitle: t('table.name', 'Name'),
            comparator: (order, rubrics, _) => {
                if (!order) return rubrics;
                const getter = (r) => {
                    return r.rubric.title.toLowerCase();
                };

                if (order === 'desc') {
                    const sortedRubrics = [...rubrics].sort((a, b) => commonDescendingComparator(a, b, getter));
                    return sortedRubrics;
                }
                const sortedRubrics = [...rubrics].sort((a, b) => -commonDescendingComparator(a, b, getter));
                return sortedRubrics;
            },
        },
        {
            id: 'lastupdated',
            columnTitle: t('table.last-updated', 'Last Updated'),
            comparator: (order, rubrics, _) => {
                if (!order) return rubrics;
                const getter = (r) => {
                    if (!r.modified_on) return null;
                    return moment(r.modified_on);
                };

                if (order === 'desc') {
                    const sortedRubrics = [...rubrics].sort((a, b) => momentDescendingComparator(a, b, getter));
                    return sortedRubrics;
                }
                const sortedRubrics = [...rubrics].sort((a, b) => -momentDescendingComparator(a, b, getter));
                return sortedRubrics;
            },
        },
        {
            id: 'criteria',
            columnTitle: t('table.criteria', 'Criteria'),
            ascSuffix: '(asc)',
            descSuffix: '(desc)',
            comparator: (order, rubrics, _) => {
                if (!order) return rubrics;
                const getter = (r) => {
                    return r.rubric.criteria.length;
                };

                if (order === 'desc') {
                    const sortedRubrics = [...rubrics].sort((a, b) => commonDescendingComparator(a, b, getter));
                    return sortedRubrics;
                }
                const sortedRubrics = [...rubrics].sort((a, b) => -commonDescendingComparator(a, b, getter));
                return sortedRubrics;
            },
        },
        {
            id: 'points',
            columnTitle: t('table.points', 'Points'),
            ascSuffix: '(asc)',
            descSuffix: '(desc)',
            comparator: (order, rubrics, _) => {
                if (!order) return rubrics;
                const getter = (r) => {
                    return r.rubric.criteria.reduce((acc, cur) => {
                        return acc + Math.max(...cur.options.map(({ rate }) => Number(rate)));
                    }, 0);
                };

                if (order === 'desc') {
                    const sortedRubrics = [...rubrics].sort((a, b) => commonDescendingComparator(a, b, getter));
                    return sortedRubrics;
                }
                const sortedRubrics = [...rubrics].sort((a, b) => -commonDescendingComparator(a, b, getter));
                return sortedRubrics;
            },
        },
    ];
};
